import { ArrowRightIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowRight = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <ArrowRightIcon color={fill || stroke} size={Sizes[size]} {...rest} />;
};

ArrowRight.displayName = 'ArrowRight';
